import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class MyLiqProcuService {


  constructor(private _http: HttpClient) {}

  getLiq(page): Observable<any> {
    const httpParams = new HttpParams({
      fromObject: page
    });
    return this._http.get<any>(`${environment.BACKEND}myLiqProcu/list`, {
      params: httpParams
    });
  }
  getStagesPreloaded(): Observable<any> {
    // const httpParams = new HttpParams({
    //   fromObject: page
    // });
    return this._http.get<any>(`${environment.BACKEND}myLiqProcu/getStagesPreloaded`, {
      //params: httpParams
    });
  }

  downloadCSV(page): Observable<any> {
    const httpParams = new HttpParams({
      fromObject: page
    });
    return this._http.get(`${environment.BACKEND}myLiqProcu/csv`, {
      params: httpParams
    });
  }

  getMotiveHistory(transferId) {
    const httpParams = new HttpParams({});
    return this._http.get(`${environment.BACKEND}transferDGR/motive-history/${transferId}`, {
      params: httpParams
    });
  }
}
